import gql from 'graphql-tag';
// Imported from the fragments sub-path (not the `modules/quote` barrel) to avoid a circular-import cycle with quote's hooks/ui
import {
  QUOTE_FEE_FRAGMENT,
  QUOTE_REBATE_FRAGMENT,
  QUOTE_EQUIPMENT_FRAGMENT,
  QUOTE_CASH_BACK_AMOUNT_FRAGMENT,
  QUOTE_EQUIPMENT_TRADE_INS_FRAGMENT,
  QUOTE_AFTERMARKET_PRODUCT_FRAGMENT,
} from 'modules/quote/api/fragments';

export const DEAL_BUILDER_QUOTE_FRAGMENT = gql`
  fragment DealBuilderQuoteFields on Quote {
    quoteId
    attributes {
      key
      description
      value
    }
    feesTotal
    fees {
      ...QuoteFeeFields
    }
    aftermarketProducts {
      ...QuoteAftermarketProductFields
    }
    aftermarketProductsTotal
    rebates {
      ...QuoteRebateFields
    }
    rebatesTotal
    cashBackAmounts {
      ...QuoteCashBackAmountFields
    }
    cashBackAmountsTotal
    tradeValueNet
    tradeValueGross
    tradeValueOwed
    equipmentTradeIns {
      ...QuoteEquipmentTradeInsFields
    }
    equipment {
      ...QuoteEquipmentFields
    }
    equipmentSubtotal
    deposit {
      type
      value
      notes
    }
    createdDateTime
    modifiedDateTime
  }
  ${QUOTE_FEE_FRAGMENT}
  ${QUOTE_REBATE_FRAGMENT}
  ${QUOTE_EQUIPMENT_FRAGMENT}
  ${QUOTE_CASH_BACK_AMOUNT_FRAGMENT}
  ${QUOTE_EQUIPMENT_TRADE_INS_FRAGMENT}
  ${QUOTE_AFTERMARKET_PRODUCT_FRAGMENT}
`;
